export const stateKeys = {
  date: 'date',
  dateStr: 'dateStr',
};
